import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  hospitalId: string;
}

type Result = {};

const options: ApiOptions = {
  method: 'patch',
  urlPath: '/hospital/deactivate',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useHospitalDeactivateLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useHospitalDeactivateLazy;
